<template>
  <div class="greybar">
    <div class="clipped artist-name">
      <ix-router-link :to="portfolioUrl">{{ artist.formatted_name }}</ix-router-link>
    </div>
    <div class="likebox-holder">
      <like-box :imageId="likeImageId" />
    </div>
    <permalink-button :image="likeImage" :artist="artist" small />
  </div>
</template>

<script>
import LikeBox from '@/components/buttons/LikeBox.vue'
import PermalinkButton from '@/components/buttons/PermalinkButton.vue'

export default {
  components: {
    LikeBox,
    PermalinkButton
  },
  props: {
    artist: {
      type: Object,
      default: function () { return {} }
    },
    likeImage: Object,
    playButton: Boolean,
    collapse: Boolean,
    animation: Boolean
  },
  computed: {
    portfolioUrl () {
      if(!this.artist) return ''
      if(this.animation) return '/animators/' + this.artist.portfolio_url
      else return '/artists/' + this.artist.portfolio_url
    },
    likeImageId () {
      if(this.likeImage) {
        return this.likeImage.image_id
      }
      return 0
    }
  }
}
</script>
<style scoped>
.tag-panel{
  display:none;
  padding-top:8px;
}
</style>
<style>
.greybar:hover .clipped{
  white-space:normal;
}

.clipped {
  overflow: hidden;
  white-space: nowrap;
  transition:all 0.2s ease;
  text-overflow: ellipsis; 
}
</style>
